import type { Language } from '@/context/LanguageContext'

export interface TrilingualRecipeRaw {
  id: string
  difficulty: 'Easy' | 'Medium' | 'Hard'
  prep_time_mins: number
  cook_time_mins: number
  serving_size: number
  youtube_search_url: string
  en: RecipeLanguageNode
  hi: RecipeLanguageNode
  mr: RecipeLanguageNode
}

interface RecipeLanguageNode {
  name: string
  description: string
  ingredients: Array<{ name: string; quantity: string }>
  instructions: string[]
  nutrition_highlights: string[]
}

export interface LocalizedRecipe {
  id: string
  name: string
  description: string
  difficulty: 'Easy' | 'Medium' | 'Hard'
  prep_time_mins: number
  cook_time_mins: number
  serving_size: number
  ingredients: Array<{ name: string; quantity: string }>
  instructions: string[]
  nutrition_highlights: string[]
  youtube_search_url: string
}

export function formatRecipeForLang(
  recipeRaw: TrilingualRecipeRaw | LocalizedRecipe,
  lang: Language
): LocalizedRecipe {
  if ('en' in recipeRaw && recipeRaw.en) {
    const node = recipeRaw[lang] ?? recipeRaw.en
    return {
      id: recipeRaw.id,
      name: node.name,
      description: node.description,
      difficulty: recipeRaw.difficulty,
      prep_time_mins: recipeRaw.prep_time_mins,
      cook_time_mins: recipeRaw.cook_time_mins,
      serving_size: recipeRaw.serving_size,
      ingredients: node.ingredients,
      instructions: node.instructions,
      nutrition_highlights: node.nutrition_highlights,
      youtube_search_url: recipeRaw.youtube_search_url,
    }
  }

  return recipeRaw as LocalizedRecipe
}
